<app-modal-frame
  [headerText]="CONSTS.HEADER"
  [rightButton]="{
    type: BUTTON_TYPES.REPORT_BUTTON,
  }"
  (emitExit)="clickExit()"
  (emitRightClick)="getReport()"
>
  <form class="container" [formGroup]="extractForm">
    <div class="content">
      <!-- Report -->
      @if (extractForm.get("reportFormat")?.enabled) {
        <ion-row class="report-row">
          <ion-col
            size="12"
            size-sm="6"
            size-md="6"
            size-lg="6"
            size-xl="12"
          >
            <app-form-select
              formControlName="report"
              class="form-select"
              [label]="CONSTS.REPORT_LABEL"
              [options]="REPORT_OPTIONS"
              [customClass]="'scan-type-dropdown report-select'"
              (update)="updateReports()"
            ></app-form-select>
          </ion-col>
          <ion-col
            size="12"
            size-sm="6"
            size-md="6"
            size-lg="6"
            size-xl="12"
          >
            <app-report-format
              [radioButtonValue]="extractForm.get('reportFormat')?.value"
              (emitRadioChange)="radioChange($event)"
            ></app-report-format>
          </ion-col>
        </ion-row>
      } @else {
        <ion-row class="report-row">
          <ion-col size="12">
            <app-form-select
              formControlName="report"
              class="form-select"
              [label]="CONSTS.REPORT_LABEL"
              [options]="REPORT_OPTIONS"
              [customClass]="'scan-type-dropdown report-select'"
              (update)="updateReports()"
            ></app-form-select>
          </ion-col>
        </ion-row>
      }

      <!-- From-To-Date -->
      <app-from-to-date
        [fromControl]="'fromDate'"
        [toControl]="'toDate'"
        [formGroupValue]="extractForm"
        [minSelectableDays]="60"
        [customMinFromDate]="min60Days"
        [customMaxFromDate]="min1Day"
        [customMinToDate]="min60Days"
        [customMaxToDate]="min1Day"
      ></app-from-to-date>

      <!-- Note -->
      <ion-row>
        <ion-col>
          <app-download-note numRows="10,000"></app-download-note>
        </ion-col>
      </ion-row>
    </div>
  </form>
</app-modal-frame>

<!-- COD Outstanding Report PDF Template -->
<app-pdf-report-generator
  #outstandingPdfContainer
  [hidden]="true"
  [columns]="OUTSTANDING_PDF_REPORT.COLUMNS"
  [columnsData]="
    codOutstandingResponse &&
    codOutstandingResponse.response.CODCollectedCleared
  "
  [dataFields]="OUTSTANDING_PDF_REPORT.DATA_FIELDS"
  [hasSingleSubHeaderView]="false"
  [columnDataFontSize]="'10px'"
  [columnWidths]="[85, 50, 125, 115, 130, 80, 65, 50, 80, 85, 80, 90]"
>
  @if (codOutstandingResponse && codOutstandingResponse.response) {
    <ng-container sub-header>
      <table
        aria-hidden="true"
        class="pdf-sub-header-table"
      >
        <tr class="pdf-sub-header-row">
          <td>
            {{ OUTSTANDING_PDF_REPORT.HEADER.LOCATION }}
            {{ codOutstandingResponse.response.location }}
          </td>
          <td>
            {{ OUTSTANDING_PDF_REPORT.HEADER.TURN_IN }}
            {{ codOutstandingResponse.response.turninDate }}
          </td>
        </tr>
      </table>
    </ng-container>
  }
  @if (codOutstandingResponse && codOutstandingResponse.response) {
    <ng-container total>
      <table
        aria-hidden="true"
        class="pdf-total-table"
      >
        <tr class="pdf-total-row">
          <td class="pdf-total-cell">
            {{ OUTSTANDING_PDF_REPORT.FOOTER.TOTAL_EXPECTED }}
            {{ codOutstandingResponse.response.TotalExpectedCOD }}
          </td>
          <td class="pdf-total-cell">
            {{ OUTSTANDING_PDF_REPORT.FOOTER.TURNED_IN }}
            {{ codOutstandingResponse.response.TotalTurnedInCOD }}
          </td>
        </tr>
      </table>
    </ng-container>
  }
</app-pdf-report-generator>

<!-- COD Collected Report PDF Template -->
<app-pdf-report-generator
  #collectedPdfContainer
  [hidden]="true"
  [columns]="PDF_REPORT.COLUMNS"
  [columnsData]="
    codCollectedResponse && codCollectedResponse.response.CODCollectedCleared
  "
  [dataFields]="PDF_REPORT.DATA_FIELDS"
  [hasSingleSubHeaderView]="false"
  [columnDataFontSize]="'10px'"
  [columnWidths]="[85, 50, 125, 115, 100, 75, 60, 45, 75, 75, 100, 85, 75]"
>
  @if (codCollectedResponse && codCollectedResponse.response) {
    <ng-container sub-header>
      <table
        aria-hidden="true"
        class="pdf-sub-header-table"
      >
        <tr class="pdf-sub-header-row">
          <td>
            {{ PDF_REPORT.HEADER.LOCATION }}
            {{ codCollectedResponse.response.location }}
          </td>
          <td>
            {{ PDF_REPORT.HEADER.TURN_IN }}
            {{ codCollectedResponse.response.turninDate }}
          </td>
        </tr>
      </table>
    </ng-container>
  }
  @if (codCollectedResponse && codCollectedResponse.response) {
    <ng-container total>
      <table
        aria-hidden="true"
        class="pdf-total-table"
      >
        <tr class="pdf-total-row">
          <td class="pdf-total-cell">
            {{ PDF_REPORT.FOOTER.TOTAL_EXPECTED }}
            {{ codCollectedResponse.response.TotalExpectedCOD }}
          </td>
          <td class="pdf-total-cell">
            {{ PDF_REPORT.FOOTER.TURNED_IN }}
            {{ codCollectedResponse.response.TotalTurnedInCOD }}
          </td>
        </tr>
      </table>
    </ng-container>
  }
</app-pdf-report-generator>
